module.exports = __webpack_public_path__ + "static/media/merriweather-light-webfont.8e9df39c.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather-light-webfont.woff2
// module id = 283
// module chunks = 0